import {sort} from 'ramda';

export const sortAscend = (field) => sort((a, b) => a[field].toString().localeCompare(b[field]));
